import React from 'react';
import { Wind, Shield, Settings, Camera, Droplets, Award } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { services } from '../data/mock';

const iconMap = {
  Wind: Wind,
  Shield: Shield,
  Settings: Settings,
  Camera: Camera,
  Droplets: Droplets,
  Award: Award,
};

const ServicesSection = () => {
  return (
    <section id="servizi" className="py-24 bg-gradient-to-b from-slate-50 to-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="inline-block px-4 py-2 bg-sky-100 text-sky-700 rounded-full text-sm font-semibold mb-4">
            I Nostri Servizi
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-800 mb-6">
            Soluzioni Complete per la{' '}
            <span className="gradient-text">Sanificazione HVAC</span>
          </h2>
          <p className="text-lg text-slate-600">
            Grazie alla nostra certificazione AIISA, garantiamo interventi di alta qualità 
            che rispettano i più rigorosi standard del settore.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => {
            const IconComponent = iconMap[service.icon];
            return (
              <Card
                key={service.id}
                className="group relative overflow-hidden border-0 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1 bg-white"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                {/* Decorative gradient */}
                <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-sky-400 to-sky-500" />
                
                <CardHeader className="pb-4">
                  <div className="w-14 h-14 bg-sky-50 rounded-xl flex items-center justify-center mb-4 group-hover:bg-sky-100 transition-colors">
                    <IconComponent className="w-7 h-7 text-sky-500" />
                  </div>
                  <CardTitle className="text-xl font-bold text-slate-800">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-slate-600 text-base leading-relaxed">
                    {service.description}
                  </CardDescription>
                </CardContent>

                {/* Hover effect background */}
                <div className="absolute inset-0 bg-gradient-to-br from-sky-500/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none" />
              </Card>
            );
          })}
        </div>

        {/* Additional info */}
        <div className="mt-16 text-center">
          <p className="text-slate-600 mb-4">
            Offriamo anche servizi di pulizia per i <strong>fan coil</strong>, 
            componenti cruciali per il mantenimento di un ambiente salubre.
          </p>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
